 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		81: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"b0ed8db24b4bbd7d0b848f587b8700e9dbeb31d1","5":"component---src-pages-404-js","6":"component---src-pages-components-accordion-mdx","7":"component---src-pages-components-alert-mdx","8":"component---src-pages-components-anchor-links-mdx","9":"component---src-pages-components-article-card-mdx","10":"component---src-pages-components-aside-mdx","11":"component---src-pages-components-avatar-mdx","12":"component---src-pages-components-badge-mdx","13":"component---src-pages-components-breadcrumb-mdx","14":"component---src-pages-components-button-mdx","15":"component---src-pages-components-button-navigation-mdx","16":"component---src-pages-components-caption-mdx","17":"component---src-pages-components-chat-mdx","18":"component---src-pages-components-code-blocks-mdx","19":"component---src-pages-components-container-mdx","20":"component---src-pages-components-divider-mdx","21":"component---src-pages-components-do-dont-example-mdx","22":"component---src-pages-components-feature-card-mdx","23":"component---src-pages-components-filter-switcher-mdx","24":"component---src-pages-components-footer-mdx","25":"component---src-pages-components-form-mdx","26":"component---src-pages-components-grid-mdx","27":"component---src-pages-components-header-mdx","28":"component---src-pages-components-image-card-mdx","29":"component---src-pages-components-image-component-mdx","30":"component---src-pages-components-input-mdx","31":"component---src-pages-components-markdown-mdx","32":"component---src-pages-components-menu-mdx","33":"component---src-pages-components-modal-mdx","34":"component---src-pages-components-navigation-mdx","35":"component---src-pages-components-overview-mdx","36":"component---src-pages-components-page-description-mdx","37":"component---src-pages-components-pagination-mdx","38":"component---src-pages-components-pop-over-mdx","39":"component---src-pages-components-progress-indicator-mdx","40":"component---src-pages-components-resource-card-mdx","41":"component---src-pages-components-sheet-mdx","42":"component---src-pages-components-slider-mdx","43":"component---src-pages-components-snack-bar-mdx","44":"component---src-pages-components-step-wizard-mdx","45":"component---src-pages-components-table-mdx","46":"component---src-pages-components-tabs-mdx","47":"component---src-pages-components-tooltip-mdx","48":"component---src-pages-components-video-mdx","49":"component---src-pages-contributions-mdx","50":"component---src-pages-demo-index-mdx","51":"component---src-pages-foundation-color-android-mdx","52":"component---src-pages-foundation-color-design-mdx","53":"component---src-pages-foundation-color-ios-mdx","54":"component---src-pages-foundation-color-web-mdx","55":"component---src-pages-foundation-elevation-android-mdx","56":"component---src-pages-foundation-elevation-design-mdx","57":"component---src-pages-foundation-elevation-ios-mdx","58":"component---src-pages-foundation-elevation-web-mdx","59":"component---src-pages-foundation-typography-android-mdx","60":"component---src-pages-foundation-typography-design-mdx","61":"component---src-pages-foundation-typography-ios-mdx","62":"component---src-pages-foundation-typography-web-mdx","63":"component---src-pages-gallery-index-mdx","64":"component---src-pages-getting-started-index-mdx","65":"component---src-pages-guides-configuration-mdx","66":"component---src-pages-guides-navigation-sidebar-mdx","67":"component---src-pages-guides-navigation-tabs-mdx","68":"component---src-pages-guides-shadowing-mdx","69":"component---src-pages-guides-styling-mdx","70":"component---src-pages-icons-js","71":"component---src-pages-index-mdx","72":"component---src-pages-labs-mdx","73":"component---src-pages-layout-container-mdx","74":"component---src-pages-layout-grid-mdx","75":"component---src-pages-overview-index-mdx","76":"component---src-pages-principle-overview-mdx","77":"component---src-pages-principle-philosophy-mdx","78":"component---src-pages-resources-mdx","79":"component---src-pages-update-mdx"}[chunkId]||chunkId) + "-" + {"1":"619849de936e1bf4d2c7","5":"325727a7188935666e1b","6":"bf20b71b693d2c408642","7":"a7684e600a0b2bde250f","8":"757b773f834cc05012e3","9":"8e9e27147e2a9bf618a5","10":"6018e58c909bf28b2238","11":"e83272f8c13fe1a2d372","12":"39a308413ddbdf30595a","13":"d0c161ffdd148d679f8f","14":"a04d2f992448b1e7d81e","15":"d34ef6111a1b29f73b53","16":"6d31d2df21f4903e9b5e","17":"5a35dcd1387569af2333","18":"02cdbc9f589daaaff413","19":"86a0278075899d2fa41f","20":"ea2d120c70891c01c044","21":"28142e789c5f24f92b01","22":"111cca22c593ef542b00","23":"b2a659b336adee91a706","24":"4ec9d658168c925b1b77","25":"ca7ed01be36d496c084b","26":"7460cfc5c20af4fe6999","27":"c6012420ba01b1cf669c","28":"36825dc7d54aac7bf7fc","29":"81dfc287d15dc1dd7438","30":"5e37275cbd8f3eb37f23","31":"b69e9b058900e33fc9e8","32":"39377d907ee3394db980","33":"72535d5326f747c8b3e5","34":"a146b42fd1635a3489b3","35":"5a0cd4afebffe3b8ee8b","36":"36cd0baf853ca5fdab5c","37":"1048c11d186f20210d51","38":"e02f38c8d4524b56a273","39":"4898bc6220ce8338d0cb","40":"3fa00f76640b7ef99f64","41":"bea3c223fa6bd6e528ef","42":"3914d2f61e6f9a18cdd1","43":"404e28d1c50f09e0f7c8","44":"1a36a582d4170205e004","45":"71e07037b1c290e48b3a","46":"ce415c8e93fb8dea7e0a","47":"7d5ee97a17502f419e23","48":"210b5a3d3af752c2e63b","49":"344411b6103ccae4d8be","50":"8af2e1519e7018ae2dce","51":"ec7faa13a05b1ef80062","52":"9b28a7bc443bc48f2691","53":"2e0004093d4e021e0327","54":"d1cc098544b6609a9900","55":"baf1c9d3e25d7b9d5a2b","56":"54b2be636281a87acf0d","57":"f0dadae3e6c9aa721603","58":"ab2e0d7b781e8a1cb33f","59":"395abbc64841f407e7b3","60":"6161a8d1a95ec4cf78fa","61":"da4134312474e4b84d16","62":"6172a92fa7ab74dc9e9c","63":"8804e4a0cc2ad21aa048","64":"caad7511a43d276b9e55","65":"874ff3082fa6f37efa26","66":"11d2ff60f4e29613b78c","67":"f198555c454a9a490726","68":"089ee2a9255b6babe0fe","69":"2e088715ced884f1d746","70":"8e6e71fcfa89ad351067","71":"74fd6784c3674ef4a877","72":"d261eb55978bece07c31","73":"c20a733079136f1d08ee","74":"248374d6ae4d37bb62e5","75":"d0726cf0af90a9a1f3d4","76":"21c7db245344215e819f","77":"01418a17584cbb0cba40","78":"c989de4bf7b8c86de1ec","79":"14d91c09b846aa654ba0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
